import { DOCUMENT } from '@angular/common';
import { ApplicationRef, createComponent, EmbeddedViewRef, Inject, Injectable } from '@angular/core';
import type { BlockUiComponent } from './block-ui.component';

@Injectable({
  providedIn: 'root'
})
export class BlockUiService {

  private blockUiComponent: BlockUiComponent;
  constructor(
    private appRef: ApplicationRef,
    @Inject(DOCUMENT) private document: Document,
  ) { }


  async load(): Promise<void> {
    await this.ensureComponent();
  }

  async setMessage(message: string): Promise<void> {
    await this.ensureComponent();
    this.blockUiComponent.setMessage(message);
  }

  async show(message?: string, timeout = 0): Promise<void> {
    await this.ensureComponent();
    if(message) {
      this.setMessage(message);
    }
    this.blockUiComponent.show(timeout);
  }

  async hide(): Promise<void> {
    await this.ensureComponent();
    this.blockUiComponent.hide();
  }

  private async ensureComponent(): Promise<void> {
    if (!this.blockUiComponent) {
      const { BlockUiComponent } = await import('./block-ui.component');
      const componentRef = createComponent(BlockUiComponent, { environmentInjector: this.appRef.injector });
      this.appRef.attachView(componentRef.hostView);
      // 3. Get DOM element from component
      const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;
      // 4. Append DOM element to the body
      this.document.body.appendChild(domElem);
      this.blockUiComponent = componentRef.instance;
    }
  }
}
